import { render, staticRenderFns } from "./PasswordProtection.vue?vue&type=template&id=19fb102a&scoped=true"
import script from "./PasswordProtection.vue?vue&type=script&lang=js"
export * from "./PasswordProtection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fb102a",
  null
  
)

export default component.exports